import { createSlice } from '@reduxjs/toolkit';
import { clone, isNumber, reduce } from 'lodash';

const initialState = {
  machineType: 'tgs',
  deviceMac: null,
  deviceStatus: null,
  isTgsSwitchActivated: false,
  displayConflictMessage: false,
  isEssSwitch: true,
  isSelected: false,

  devicesConflicts: {
    systemTarget: '',
    currentSwitch: '',
    DesiredSwitch: '',
    commandTarget: '',
    extraData: null,
  },

  isOff: false,
  freezeBy: null,
  isTESActive: false,

  isExpanded: false,
  openMachineController: false,

  isFaults: false,
  isGp: true,
  isEbp: false,
  atsSelection: [],
  isWifi: false,
  thermocouple: false,

  currentTemp: null,
  setTemp: null,

  currentTemp: null,
  setTemp: null,
  consumption: null,
  enclosureTemp: null,
  outSideTemp: null,
  hoursOfUsage: null,

  heatingSystemAbbr: '',
  usageHours: 650,
  energyConsump: 1200,
  reading: 30,
  address: { lat: 42.36997, lng: -71.070647 },

  instantHeat: { inputTemp: 0, isReady: false, isActivated: false },
  fanOnly: false,
  snowSensor: {
    isReady: false,
    isActivated: false,
    defaultTemp: 350,
  },

  optionalConstantTemp: {
    inputTemp: 0,
    apply: false,
    isActivated: false,
    isReady: false,
  },

  heatingScheduleList: [
    {
      start: { date: null, time: null },
      end: { date: null, time: null },
      inputTemp: null,
      id: null,
    },
  ],

  heatingSchedule: {
    isReady: false,
    isActivated: false,
    disable: false,
  },

  windFactor: { isReady: false, isActivated: false },

  mobileSelectedProgram: {
    instantHeat: false,
    snowSensor: false,
    windFactor: false,
    fanOnly: false,
    ats: false,
    shutOff: false,
    heatingSchedule: false,
  },

  heaterGraphData: [],
  enclosureGraphData: [],
  outsideGraphData: [],
  gasGraphData: [],
  snowGraphData: [],
  windGraphData: [],

  graphDateData: {
    heaterGraphData: [],
    enclosureGraphData: [],
    outsideGraphData: [],
    gasGraphData: [],
    snowGraphData: [],
    windGraphData: [],
    energyGasConsumptionGraphData: [],
    dataConsumptionGraphData: [],
    intervalUnit: '',
  },
};

const tgsSwitchSlice = createSlice({
  name: 'tgsSwitch',
  initialState: {
    'mtl-east': {
      '01': initialState,
      '02': initialState,
      '03': initialState,
      '04': initialState,
      '05': initialState,
    },
    'mtl-west': {
      '01': initialState,
      '02': initialState,
      '03': initialState,
      '04': initialState,
      '05': initialState,
    },
    'mtl-south': {
      '01': initialState,
      '02': initialState,
      '03': initialState,
      '04': initialState,
      '05': initialState,
    },
    tgsSwitch: {},
    flatTgsSwitch: {},
  },
  reducers: {
    tgsHandleSelectIndividualMachine: (state, action) => {
      const { location, specificLocation, machine } = action.payload;
      if (specificLocation) {
        state.flatTgsSwitch[location][specificLocation][machine].isSelected =
          true;
      } else {
        state.flatTgsSwitch[location][machine].isSelected = true;
      }
    },
    tgsSpecificLocationSelectMachinesHandler: (state, action) => {
      state.flatTgsSwitch[action.payload.specificLocation][
        action.payload.machine
      ].isSelected = true;
    },
    tgsHandleUnSelectIndividualMachine: (state, action) => {
      const { location, specificLocation, machine } = action.payload;
      if (specificLocation) {
        state.flatTgsSwitch[location][specificLocation][machine].isSelected =
          false;
      } else {
        state.flatTgsSwitch[location][machine].isSelected = false;
      }
    },
    tgsSpecificLocationUnselectMachinesHandler: (state, action) => {
      state.flatTgsSwitch[action.payload.location][
        action.payload.specificLocation
      ][action.payload.machine].isSelected = false;
    },
    tgsHandleInstantHeat: (state, action) => {
      state.flatTgsSwitch[action.payload.location][
        action.payload.machine
      ].instantHeat.inputTemp = action.payload.temp;

      state.flatTgsSwitch[action.payload.location][
        action.payload.machine
      ].instantHeat.isReady = true;
    },
    tgsHandleInstantHeatIsReady: (state, action) => {
      const { location, specificLocation, machine, temp } = action.payload;
      if (specificLocation) {
        const instantHeatData =
          state.flatTgsSwitch[location][specificLocation][machine].instantHeat;
        instantHeatData.inputTemp = temp;
        instantHeatData.isReady = true;

      } else {
        const instantHeatData =
          state.flatTgsSwitch[location][machine].instantHeat;
        instantHeatData.inputTemp = temp;

        instantHeatData.isReady = true;
      }
    },
    tgsHandleInstantHeatOff: (state, action) => {
      const { location, specificLocation, machine } = action.payload;
      if (specificLocation) {
        const instantHeatData =
          state.flatTgsSwitch[location][specificLocation][machine].instantHeat;
        instantHeatData.isActivated = false;
        instantHeatData.isReady = false;

      } else {
        const instantHeatData =
          state.flatTgsSwitch[location][machine].instantHeat;
        instantHeatData.isActivated = false;
        instantHeatData.isReady = false;
      }
    },
    tgsHandleInstantHeatReset: (state, action) => {
      if (action.payload.specificLocation) {
        state.flatTgsSwitch[action.payload.location][
          action.payload.specificLocation
        ][action.payload.machine].instantHeat = { ...initialState.instantHeat };
      } else {
        state.flatTgsSwitch[action.payload.location][
          action.payload.machine
        ].instantHeat = { ...initialState.instantHeat };
      }
    },
    tgsHandleSnowSensor: (state, action) => {
      const { location, specificLocation, machine } = action.payload;
      if (specificLocation) {
        state.flatTgsSwitch[location][specificLocation][
          machine
        ].snowSensor.isReady = true;
      } else {
        state.flatTgsSwitch[location][machine].snowSensor.isReady = true;
      }
    },
    tgsHandleSnowSensorOff: (state, action) => {
      if (action.payload.specificLocation) {
        state.flatTgsSwitch[action.payload.location][
          action.payload.specificLocation
        ][action.payload.machine].snowSensor.isReady = false;
      } else {
        state.flatTgsSwitch[action.payload.location][
          action.payload.machine
        ].snowSensor.isReady = false;
      }
    },
    tgsHandleSnowSensorReset: (state, action) => {
      if (action.payload.specificLocation) {
        state.flatTgsSwitch[action.payload.location][
          action.payload.specificLocation
        ][action.payload.machine].snowSensor = { ...initialState.snowSensor };
      } else {
        state.flatTgsSwitch[action.payload.location][
          action.payload.machine
        ].snowSensor = { ...initialState.snowSensor };
      }
    },

    tgsHandleWindFactor: (state, action) => {
      const { location, specificLocation, machine } = action.payload;
      if (specificLocation) {
        state.flatTgsSwitch[location][specificLocation][
          machine
        ].windFactor.isReady = true;
      } else {
        state.flatTgsSwitch[location][machine].windFactor.isReady = true;
      }
    },
    tgsHandleWindFactorOff: (state, action) => {
      const { location, specificLocation, machine } = action.payload;
      if (specificLocation) {
        state.flatTgsSwitch[location][specificLocation][
          machine
        ].windFactor.isReady = false;
      } else {
        state.flatTgsSwitch[location][machine].windFactor.isReady = false;
      }
    },
    tgsHandleWindFactorReset: (state, action) => {
      const { location, specificLocation, machine } = action.payload;
      if (specificLocation) {
        state.flatTgsSwitch[location][specificLocation][machine].windFactor = {
          ...initialState.windFactor,
        };
      } else {
        state.flatTgsSwitch[location][machine].windFactor = {
          ...initialState.windFactor,
        };
      }
    },
    tgsHandleAddHeatingSchedule: (state, action) => {
      const {
        location,
        specificLocation,
        machine,
        start,
        end,
        index,
        inputTemp,
        id,
      } = action.payload;
      const heatingSchedule = {
        start: start,
        end: end,
        inputTemp: inputTemp,
        id: id,
      };
      const resetHeatingSchedule = {
        start: { date: null, time: null },
        end: { date: null, time: null },
        inputTemp: null,
        id: null,
      };
      state.flatTgsSwitch[location][machine].heatingScheduleList[index] =
        heatingSchedule;

      state.flatTgsSwitch[location][machine].heatingScheduleList[index + 1] =
        resetHeatingSchedule;
    },
    tgsHandleReadyHeatingSchedule: (state, action) => {
      const { location, machine } = action.payload;
      state.flatTgsSwitch[location][machine].heatingSchedule.isReady =
        action.payload.state;
    },

    tgsHandleClearHeatingSchedule: (state, action) => {
      const { location, specificLocation, machine, data } = action.payload;
      if (specificLocation) {
        state.flatTgsSwitch[location][specificLocation][
          machine
        ].heatingScheduleList = data;
      } else {
        state.flatTgsSwitch[location][machine].heatingScheduleList = data;
      }
    },
    tgsHandleHeatingScheduleReset: (state, action) => {
      const { location, specificLocation, machine } = action.payload;
      if (specificLocation) {
        const machineData =
          state.flatTgsSwitch[location][specificLocation][machine];
        machineData.heatingScheduleList = {
          ...initialState.heatingScheduleList,
        };
        machineData.heatingSchedule = {
          ...initialState.heatingSchedule,
        };
      } else {
        const machineData = state.flatTgsSwitch[location][machine];
        machineData.heatingScheduleList = {
          ...initialState.heatingScheduleList,
        };
        machineData.heatingSchedule = {
          ...initialState.heatingSchedule,
        };
      }
    },

    tgsHandleShutOff: (state, action) => {
      const { location, specificLocation, machine } = action.payload;
      if (specificLocation) {
        if (state.flatTgsSwitch[location][specificLocation][machine].isOff) {
          state.flatTgsSwitch[location][specificLocation][machine].isOff =
            false;
        } else {
          state.flatTgsSwitch[location][specificLocation][machine].isOff = true;
        }
      } else {
        if (state.flatTgsSwitch[location][machine].isOff) {
          state.flatTgsSwitch[location][machine].isOff = false;
        } else {
          state.flatTgsSwitch[location][machine].isOff = true;
        }
      }
    },
    tgsResetMachinesState: (state, action) => {
      const { location, specificLocation, machine } = action.payload;

      const target = specificLocation
        ? state.flatTgsSwitch[location]?.[specificLocation]?.[machine]
        : state.flatTgsSwitch[location]?.[machine];

      if (!target) return;

      target.instantHeat = { ...initialState.instantHeat };
      target.optionalConstantTemp = { ...initialState.optionalConstantTemp };
      target.windFactor = { ...initialState.windFactor };
      target.heatingSchedule = { ...initialState.heatingSchedule };
      target.heatingScheduleList = initialState.heatingScheduleList.map(
        (schedule) => ({ ...schedule }),
      );
      target.fanOnly = initialState.fanOnly;
      target.snowSensor = {
        ...initialState.snowSensor,
        defaultTemp: target.snowSensor?.defaultTemp ?? null,
      };
    },
    tgsHandleFanOnly: (state, action) => {
      if (action.payload.specificLocation) {
        state.flatTgsSwitch[action.payload.scope || action.payload.location][
          action.payload.specificLocation
        ][action.payload.machine].fanOnly = action.payload.state;
      } else {
        state.flatTgsSwitch[action.payload.scope || action.payload.location][
          action.payload.machine
        ].fanOnly = action.payload.state;
      }
    },

    tgsHandleOpenMachineController: (state, action) => {
      const { location, specificLocation, machine, status } = action.payload;

      if (specificLocation) {
        state.flatTgsSwitch[location][specificLocation][
          machine
        ].openMachineController = status;
      } else {
        state.flatTgsSwitch[location][machine].openMachineController = status;
      }

    },

    tgsHandleAtsSelection: (state, action) => {
      const { location, specificLocation, machine, selection } = action.payload;
      if (specificLocation) {
        state.flatTgsSwitch[location][specificLocation][machine].atsSelection =
          selection;
      } else {
        state.flatTgsSwitch[location][machine].atsSelection = selection;
      }
    },

    tgsHandleUnselectAllProgram: (state, action) => {
      const { location, specificLocation, machine } = action.payload;
      const resetProgram = {
        instantHeat: false,
        snowSensor: false,
        windFactor: false,
        fanOnly: false,
        ats: false,
        shutOff: false,
        heatingSchedule: false,
      };
      if (specificLocation) {
        state.flatTgsSwitch[location][specificLocation][
          machine
        ].mobileSelectedProgram = resetProgram;
      } else {
        state.flatTgsSwitch[location][machine].mobileSelectedProgram =
          resetProgram;
      }
    },
    tgsHandleSelectProgram: (state, action) => {
      state.flatTgsSwitch[action.payload.location][
        action.payload.machine
      ].mobileSelectedProgram[action.payload.program] =
        !state.flatTgsSwitch[action.payload.location][action.payload.machine]
          .mobileSelectedProgram[action.payload.program];
    },
    handleTgsSwitch: (state, action) => {
      delete state['mtl-east'];
      delete state['mtl-west'];
      delete state['mtl-south'];

      const zones = action.payload.tgsZones;

      state.tgsSwitch = reduce(
        zones,
        (result, location) => {
          if (location.specific_location) {
            return {
              ...result,
              [location.zone_id]: {
                isSpecificLocation: true,
                subLocations: location.specific_location.reduce(
                  (result, specificLocation) => {
                    result[specificLocation.zone_id] = {
                      devices: reduce(
                        specificLocation.devices,
                        (result, machine) => {
                          return {
                            ...result,
                            [machine.device_mac]: {
                              ...initialState,
                              address: {
                                lat: location.latitude,
                                lng: location.longitude,
                              },
                              machineName: machine.device_name,
                              locationId: location.zone_id,
                              locationName: location.zone_name,
                              locationAddress: location.zone_address || '',
                              specificLocationName:
                                specificLocation.specific_address || '',
                              isOff: machine.freeze,
                              ...extractDataFromMachine(machine),
                            },
                          };
                        },
                        {},
                      ),
                    };
                    return result;
                  },
                  {},
                ),
              },
            };
          }
          return {
            ...result,
            [location.zone_id]: {
              isSpecificLocation: false,
              devices: reduce(
                location.devices,
                (result, machine) => {
                  return {
                    ...result,
                    [machine.device_mac]: {
                      ...initialState,
                      address: {
                        lat: location.latitude,
                        lng: location.longitude,
                      },
                      machineName: machine.device_name,
                      locationId: location.zone_id,
                      locationName: location.zone_name,
                      locationAddress: location.zone_address || '',
                      specificLocationName: location.specific_address || '',
                      isOff: machine.freeze,
                      ...extractDataFromMachine(machine),
                    },
                  };
                },
                {},
              ),
            },
          };
        },
        {},
      );
      state.flatTgsSwitch = reduce(
        zones,
        (result, value) => {
          if (value.specific_location) {
            return {
              ...result,
              ...reduce(
                value.specific_location,
                (result, location) => ({
                  ...result,
                  [location.zone_id]: reduce(
                    location.devices,
                    (result, machine) => ({
                      ...result,
                      [machine.device_mac]: {
                        ...initialState,
                        address: {
                          lat: location.latitude,
                          lng: location.longitude,
                        },
                        machineName: machine.device_name,
                        parentLocationId: value.zone_id,
                        locationId: location.zone_id,
                        locationName: location.zone_name,
                        locationAddress: location.zone_address || '',
                        specificLocationName: location.specific_address || '',
                        isOff: machine.freeze,
                        ...extractDataFromMachine(machine),
                      },
                    }),
                    {},
                  ),
                }),
                {},
              ),
            };
          }
          return {
            ...result,
            [value.zone_id]: reduce(
              value.devices,
              (result, machine) => ({
                ...result,
                [machine.device_mac]: {
                  ...initialState,
                  address: {
                    lat: value.latitude,
                    lng: value.longitude,
                  },
                  machineName: machine.device_name,
                  locationId: value.zone_id,
                  locationName: value.zone_name,
                  locationAddress: value.zone_address || '',
                  specificLocationName: value.specific_address || '',
                  isOff: machine.freeze,
                  ...extractDataFromMachine(machine),
                },
              }),
              {},
            ),
          };
        },
        {},
      );
    },
    handleTgsSwitchSocket: (state, action) => {
      const data = action.payload.data;
      const location = data.zoneInfo.zone_id;
      const machine = data.device_mac;
      if (!state.flatTgsSwitch[location]) {
        state.flatTgsSwitch[location] = {};
      }

      if (!state.flatTgsSwitch[location][machine]) {
        state.flatTgsSwitch[location][machine] = {};
      }

      state.flatTgsSwitch[location][machine] = {
        ...state.flatTgsSwitch[location][machine],
        ...extractDataFromMachine(data),
      };
    },
    tgsActivateConflictMessage: (state, action) => {
      const { location, specificLocation, machine } = action.payload;
      if (specificLocation) {
        state.flatTgsSwitch[location][specificLocation][
          machine
        ].displayConflictMessage = true;
      } else {
        state.flatTgsSwitch[location][machine].displayConflictMessage = true;
      }
    },
    tgsDeactivateConflictMessage: (state, action) => {
      const { location, specificLocation, machine } = action.payload;
      if (specificLocation) {
        state.flatTgsSwitch[location][specificLocation][
          machine
        ].displayConflictMessage = false;
      } else {
        state.flatTgsSwitch[location][machine].displayConflictMessage = false;
      }
    },
    tgsSetDevicesConflicts: (state, action) => {
      const {
        location,
        specificLocation,
        machine,
        currentSwitch,
        DesiredSwitch,
        systemTarget,
        commandTarget,
        extraData,
      } = action.payload;
      const dispatchData = {
        currentSwitch,
        desiredSwitch: DesiredSwitch,
        systemTarget,
        commandTarget,
        extraData,
      };
      if (specificLocation) {
        state.flatTgsSwitch[location][specificLocation][
          machine
        ].devicesConflicts = dispatchData;
      } else {
        state.flatTgsSwitch[location][machine].devicesConflicts = dispatchData;
      }
    },
    handleTgsGraph: (state, action) => {
      const { location, specificLocation, machine, graphType, data } =
        action.payload;
      if (specificLocation) {
        state.flatTgsSwitch[location][specificLocation][machine] = {
          ...state.flatTgsSwitch[location][specificLocation][machine],
          [graphType]: data,
        };
      } else {
        state.flatTgsSwitch[location][machine] = {
          ...state.flatTgsSwitch[location][machine],
          [graphType]: data,
        };
      }
    },
    handleTgsGraphDate: (state, action) => {
      const { location, specificLocation, machine, graphType, data, unit } =
        action.payload;
      if (specificLocation) {
        const machineData =
          state.flatTgsSwitch[location][specificLocation][machine];
        machineData.graphDateData = {
          ...machineData.graphDateData,
          [graphType]: data,
        };

        if (graphType !== 'dataConsumptionGraphData') {
          machineData.graphDateData.intervalUnit = unit;
        }
      } else {
        const machineData = state.flatTgsSwitch[location][machine];
        machineData.graphDateData = {
          ...machineData.graphDateData,
          [graphType]: data,
        };

        if (graphType !== 'dataConsumptionGraphData') {
          machineData.graphDateData.intervalUnit = unit;
        }
      }
    },
  },
});

const extractDataFromMachine = (machine) => {
  const isMachineActive = machine.device_active === 1;

  return {
    ...machine,
    deviceMac: machine.device_mac,
    deviceStatus: machine.device_status,
    usageHours: isNumber(machine.hours_of_usage)
      ? Math.floor(machine.hours_of_usage / 3600)
      : null,
    reading: isNumber(machine.gas_reading)
      ? Math.floor(machine.gas_reading)
      : null,
    hoursOfUsage: isNumber(machine.hours_of_usage)
      ? Math.floor(machine.hours_of_usage / 3600)
      : null,
    enclosureTemp:
      isMachineActive && isNumber(machine.enclosure_temp)
        ? Math.floor(machine.enclosure_temp)
        : null,
    outSideTemp:
      isMachineActive && isNumber(machine.outside_temp)
        ? Math.floor(machine.outside_temp)
        : null,
    consumption:
      isMachineActive && isNumber(machine.gas_consumption)
        ? Math.round(machine.gas_consumption * 10) / 10
        : null,
    setTemp:
      isMachineActive && isNumber(machine.threshold_temp)
        ? Math.floor(machine.threshold_temp)
        : null,
    currentTemp:
      isMachineActive && isNumber(machine.display_temp)
        ? Math.floor(machine.display_temp)
        : null,
    isEbp: (machine.EBP === 1 || machine.EBP === true) && isMachineActive,
    isGp: (machine.EBP === 0 || machine.EBP === false) && isMachineActive,
    EBP_mode: machine.EBP_mode,
    instantHeat: {
      ...initialState.instantHeat,
      inputTemp: isNumber(machine.instant_temp) ? machine.instant_temp : null,
      isReady: isMachineActive && machine.on_switch === 1,
      isActivated:
        isMachineActive &&
        machine.on_switch === 1 &&
        machine.op_mode === 'SWITCH',
    },
    fanOnly: machine.fan === 1,
    snowSensor: {
      ...initialState.snowSensor,
      defaultTemp: isNumber(machine.blower_snow_threshold)
        ? Math.floor(machine.blower_snow_threshold)
        : null,
      isReady: isMachineActive && machine.snow_enabled === 1,
      isActivated:
        isMachineActive &&
        machine.snow_enabled === 1 &&
        machine.snow_trigger === 1,
    },
    windFactor: {
      ...initialState.windFactor,
      isReady: isMachineActive && machine.wind_enabled === 1,
      isActivated:
        isMachineActive &&
        machine.wind_enabled === 1 &&
        machine.wind_trigger === 1,
    },
    heatingSchedule: {
      ...machine.heatingSchedule,
      isActivated: machine.schedule_enabled === 1,
    },
    isWifi: isMachineActive,
    isDisabled: !isMachineActive || machine.op_mode === 'FAULT',
    isFanDisabled: !isMachineActive,
    machineMode: machine.op_mode,
    thermocouple: machine.tc_mode === 1,
    currentRun: machine.current_run,
    isFaults:
      isMachineActive &&
      (machine?.bms_fault === 1 ||
        machine?.hplp_fault === 1 ||
        machine?.timeout_fault === 1 ||
        machine?.thermocouple_fault === 1),
    bmsFault: (isMachineActive && machine.bms_fault) || 0,
    hplpFault: (isMachineActive && machine.hplp_fault) || 0,
    timeoutFault: (isMachineActive && machine.timeout_fault) || 0,
    thermocoupleFault: (isMachineActive && machine.thermocouple_fault) || 0,
    isTESActive: machine.TES_enabled,
    switch_panels: machine.switch_panels,
    freezeBy: machine.freeze_by,
    ...(!isMachineActive && {
      heatingSchedule: {
        ...machine.heatingSchedule,
        isReady: false,
        isActivated: false,
      },
      heaterGraphData: [],
      enclosureGraphData: [],
      outsideGraphData: [],
      gasGraphData: [],
      snowGraphData: [],
      windGraphData: [],
    }),
  };
};

export default tgsSwitchSlice;
export const selectTgsSwitch = (state) => state.tgsSwitch;
export const selectFlatTgsSwitch = (state) => {
  return state.tgsSwitch;
};
export const {
  tgsHandleSelectIndividualMachine,
  tgsSpecificLocationSelectMachinesHandler,
  tgsHandleUnSelectIndividualMachine,
  tgsSpecificLocationUnselectMachinesHandler,

  tgsHandleInstantHeat,
  tgsHandleInstantHeatIsReady,
  tgsHandleInstantHeatOff,
  tgsHandleInstantHeatReset,

  tgsHandleSnowSensor,
  tgsHandleSnowSensorOff,
  tgsHandleSnowSensorReset,

  tgsHandleWindFactor,
  tgsHandleWindFactorOff,
  tgsHandleWindFactorReset,

  tgsHandleAts,
  tgsHandleShutOff,
  tgsResetMachinesState,

  tgsHandleFanOnly,

  tgsHandleAddHeatingSchedule,
  tgsHandleReadyHeatingSchedule,
  tgsHandleClearHeatingSchedule,
  tgsHandleHeatingScheduleReset,

  tgsHandleOpenMachineController,
  tgsHandleAtsSelection,

  tgsHandleUnselectAllProgram,
  tgsHandleSelectProgram,

  tgsHandleHeatingSchedule,

  handleTgsSwitch,
  handleTgsSwitchSocket,
  tgsActivateConflictMessage,
  tgsDeactivateConflictMessage,
  tgsSetDevicesConflicts,
  handleTgsGraph,
  handleTgsGraphDate,
} = tgsSwitchSlice.actions;
